import type { ComponentPropsWithRef, ReactNode } from 'react'
import { useId } from 'react'

import { cn } from '../lib/cn'

export interface CheckboxProps extends Omit<ComponentPropsWithRef<'input'>, 'type'> {
  /** Libellé cliquable placé à droite de la case. */
  readonly label: ReactNode
  /** Précision sous le libellé (conséquence de l’option, règle métier…). */
  readonly aide?: ReactNode | undefined
}

export function Checkbox({ label, aide, className, id, ...reste }: CheckboxProps) {
  const idAuto = useId()
  const idChamp = id ?? idAuto
  const idAide = `${idChamp}-aide`

  return (
    <div className={cn('flex gap-2.5', className)}>
      <input
        type="checkbox"
        id={idChamp}
        // Plus grosse au doigt qu’à la souris : 16 px est intouchable sur un
        // téléphone. Le libellé reste cliquable et élargit d’autant la cible.
        className="mt-0.5 size-5 shrink-0 rounded border-slate-400 text-rideau-700 accent-rideau-700 sm:size-4"
        aria-describedby={aide === undefined ? undefined : idAide}
        {...reste}
      />
      <div className="text-sm leading-tight">
        <label htmlFor={idChamp} className="font-medium text-slate-800">
          {label}
        </label>
        {aide !== undefined && (
          <p id={idAide} className="mt-1 text-slate-500">
            {aide}
          </p>
        )}
      </div>
    </div>
  )
}
